var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author Soongjin Park
 * @contact sjpark@detech.co.kr
 * @date 2022-09-01
 * @brief EHP 사업장 관리 개발
 *
 ********************************************************************/
import React, { useEffect, useRef, useState } from "react";
import { useAsync } from "react-async";
import { useNavigate } from 'react-router-dom';
// recoil
import { useRecoilValue, useRecoilState, } from "recoil";
import { userInfoLoginState } from "../../../../recoil/userState";
import { loadingBoxState } from "../../../../recoil/menuState";
// utils
import clog from "../../../../utils/logUtils";
import * as CONST from "../../../../utils/Const";
import * as HTTPUTIL from "../../../../utils/api/HttpUtil";
import * as CUTIL from "../../../../utils/commUtils";
//component
import EhpPostCode from "../../../common/postcode/EhpPostCode";
import EhpImageCrop from "../../../common/imagecrop/EhpImageCrop";
/**
 * @brief EHP 사업장 관리 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
function ZoneList(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    //props
    const isMobile = props.isMobile;
    const setParentIsMobile = props.setIsMobile;
    const selTree = props.selTree;
    const setParentSelTree = props.setSelTree;
    const workMode = props.workMode;
    const setParentWorkMode = props.setWorkMode;
    const setParentAdminType = props.setAdminType;
    const setParentPopWin = props.setPopWin;
    //
    const companyInfo = props.companyInfo;
    const zoneList = companyInfo.zone;
    //
    //화면 이동
    const navigate = useNavigate();
    //mobile check
    /*const mobileRef = useRef(null); // Mobile Check용
    useEffect(() => { // resize handler
      function handleResize() {
        if (CUTIL.isnull(mobileRef)) return;
        const mobileTag = mobileRef.current;
        if ((mobileTag.clientHeight <= 0) && (mobileTag.clientWidth <= 0)) {
          setParentIsMobile(true);
        } else {
          setParentIsMobile(false);
        }
      }
      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener('resize', handleResize);
      }
    }, []);
    useEffect(() => { // re-rendering mobile check
      if (CUTIL.isnull(mobileRef)) return;
      const mobileTag = mobileRef.current;
      if (!CUTIL.isnull(mobileTag)) {
        if ((mobileTag.clientHeight <= 0) && (mobileTag.clientWidth <= 0)) {
          setParentIsMobile(true);
        } else {
          setParentIsMobile(false);
        }
      }
    }, []);*/
    ////////////////////////////////////////////////////////////////////////////
    function onClickZoneViewPopup(e, zone) {
        clog("onClickZoneViewPopup : " + JSON.stringify(zone));
        setParentPopWin("pop-listbox-detail", React.createElement(ZoneViewPopup, { htmlHeader: React.createElement("h1", null, "\uC0AC\uC5C5\uC7A5 \uC0C1\uC138 \uC815\uBCF4"), zoneInfo: zone, companyInfo: companyInfo, setSelTree: props.setSelTree, setWorkMode: props.setWorkMode, setPopWin: props.setPopWin }));
        CUTIL.jsopen_Popup(e);
    }
    //사업장 추가
    function onClickZoneInsert(e, company) {
        e.stopPropagation();
        setParentSelTree("ZONE", {
            company: { "companyId": company.companyId, "companyName": company.companyName, },
        });
        setParentWorkMode("CREATE");
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "content__info boxlist" },
            React.createElement("div", { className: "column" },
                React.createElement("div", { className: "listbox__top" },
                    React.createElement("h3", null, "\uC0AC\uC5C5\uC7A5"),
                    React.createElement("button", { type: "button", className: "add__item", onClick: (e) => onClickZoneInsert(e, companyInfo) },
                        React.createElement("span", null, "\uC0AC\uC5C5\uC7A5 \uCD94\uAC00"))),
                React.createElement("div", { className: "listbox__area" }, (zoneList) && zoneList.map((zone, idx) => (React.createElement("div", { key: `zone_${idx.toString()}`, className: "listbox" },
                    React.createElement("div", { className: "box__top" },
                        React.createElement("p", null, zone.zoneName),
                        React.createElement("button", { type: "button", className: "btn-go js-open", "data-pop": "pop-listbox-detail", onClick: (e) => onClickZoneViewPopup(e, zone) },
                            React.createElement("span", { className: "hide" }, "\uC790\uC138\uD788\uBCF4\uAE30"))),
                    React.createElement("div", { className: "box__bottom" },
                        React.createElement("div", { className: "left img_workplace" }, (zone.image !== null)
                            ? React.createElement("img", { src: zone.image.url, alt: zone.image.name })
                            : React.createElement("img", { src: require("/static/img/img_workplace/bg_add.jpg"), alt: "\uC0AC\uC9C4\uC601\uC5ED" })),
                        React.createElement("div", { className: "right" },
                            React.createElement("ul", null,
                                React.createElement("li", null,
                                    React.createElement("span", null, "\uC0C1\uC138\uC0AC\uC5C5\uC7A5"),
                                    React.createElement("span", null,
                                        React.createElement("strong", null, zone.subZoneCount),
                                        "\uAC1C")),
                                React.createElement("li", null,
                                    React.createElement("span", null, "\uB4F1\uB85D \uAE30\uAE30"),
                                    React.createElement("span", null,
                                        React.createElement("strong", null, zone.itemCount),
                                        "\uAC1C")),
                                React.createElement("li", null,
                                    React.createElement("span", null, "User"),
                                    React.createElement("span", null,
                                        React.createElement("strong", null, zone.userCount),
                                        "\uBA85"))),
                            React.createElement("ul", null,
                                React.createElement("li", null,
                                    React.createElement("p", { className: "tit" }, "\uC9C4\uB2E8 \uC810\uC218 \uAE30\uC900")),
                                React.createElement("li", null,
                                    React.createElement("div", { className: "result__score" },
                                        React.createElement("p", { className: "tit caution" }, "Warning"),
                                        React.createElement("p", { className: "score" }, zone.assessmentScore))),
                                React.createElement("li", null))))))))))));
}
;
export default ZoneList;
function ZoneViewPopup(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    //화면 이동
    const navigate = useNavigate();
    //props function
    const selTree = props.selTree;
    const setParentSelTree = props.setSelTree;
    const workMode = props.workMode;
    const setParentWorkMode = props.setWorkMode;
    const companyInfo = props.companyInfo;
    const setParentPopWin = props.setPopWin;
    //
    const [zoneInfo, setZoneInfo] = useState(null);
    const [updateCount, setUpdateCount] = useState(0);
    const { data: retData, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/product/company/zone/admindetail?zoneId=${props.zoneInfo.zoneId}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        //watch: props.zoneInfo.zoneId+workMode
        watch: props.zoneInfo.zoneId + updateCount + workMode
    });
    useEffect(() => {
        setRecoilIsLoadingBox(true);
        const ERR_URL = HTTPUTIL.resultCheck(isLoading, retData);
        if (ERR_URL.length > 0) {
            setRecoilIsLoadingBox(false);
            navigate(ERR_URL);
        }
        if (retData) {
            setRecoilIsLoadingBox(false);
            clog("IN ZONE VIEW POPUP : RES : " + JSON.stringify(retData));
            if (retData.codeNum == CONST.API_200) {
                setZoneInfo(retData.body);
            }
        }
    }, [zoneInfo, retData]);
    function onClickZoneUpdatePopup(e, zone) {
        CUTIL.jsclose_Popup("pop-listbox-detail");
        setParentPopWin("pop-listbox-detail-edit", React.createElement(ZoneUpdatePopup, { htmlHeader: React.createElement("h1", null, "\uC0AC\uC5C5\uC7A5 \uC815\uBCF4 \uC218\uC815"), zoneInfo: zoneInfo, setZoneInfo: setZoneInfo, companyInfo: companyInfo, setSelTree: props.setSelTree, setWorkMode: props.setWorkMode, updateCount: updateCount, setUpdateCount: setUpdateCount, setPopWin: props.setPopWin }));
        CUTIL.jsopen_Popup(e);
    }
    function onClickDoDeleteZone(e, zone) {
        return __awaiter(this, void 0, void 0, function* () {
            var isOk = confirm("사업장을 삭제하시겠습니까?");
            clog("onClickZoneDoDelete : " + isOk);
            if (!isOk)
                return;
            let data = null;
            setRecoilIsLoadingBox(true);
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "DELETE",
                "appPath": `/api/v2/product/company/zone/${zone.zoneId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                const ERR_URL = HTTPUTIL.resultCheck(false, data);
                if (ERR_URL.length > 0) {
                    setRecoilIsLoadingBox(false);
                    CUTIL.sleep(500);
                    navigate(ERR_URL);
                }
                if (data.codeNum == CONST.API_200) {
                    clog("IN ZONE UPDATE : onClickZoneDoDelete : " + JSON.stringify(data.body));
                    alert("사업장을 삭제 하였습니다.");
                    CUTIL.jsclose_Popup("pop-listbox-detail");
                    setParentSelTree("COMPANY", Object.assign(Object.assign({}, selTree), { company: { "companyId": companyInfo.companyId, "companyName": companyInfo.companyName }, reload: true }));
                    setParentWorkMode("READ");
                    setUpdateCount(0);
                }
                else { // api if
                    // need error handle -> goto system error page?
                    //setErrorList(data.body.errorList);
                }
            }
            setRecoilIsLoadingBox(false);
        });
    }
    function onClickClose(e) {
        CUTIL.jsclose_Popup("pop-listbox-detail");
    }
    return (React.createElement(React.Fragment, null,
        (zoneInfo) && React.createElement("div", { className: "popup__body" },
            React.createElement("div", { className: "workplace__info mt-16" },
                React.createElement("div", { className: "img_workplace" }, (zoneInfo.image !== null)
                    ? React.createElement("img", { src: zoneInfo.image.url, alt: zoneInfo.image.name })
                    : React.createElement("img", { src: require("/static/img/img_workplace/bg_add.jpg"), alt: "\uC0AC\uC9C4\uC601\uC5ED" })),
                React.createElement("div", { className: "txt_workplace" },
                    React.createElement("div", { className: "page-top" },
                        React.createElement("h2", null,
                            companyInfo.companyName,
                            " ",
                            zoneInfo.zoneName),
                        React.createElement("div", { className: "top-button" },
                            React.createElement("button", { type: "button", className: "btn-edit", "data-pop": "pop-listbox-detail-edit", onClick: (e) => onClickZoneUpdatePopup(e, zoneInfo) },
                                React.createElement("span", { className: "hide" }, "\uC218\uC815")),
                            React.createElement("button", { type: "button", className: "btn-delete", onClick: (e) => onClickDoDeleteZone(e, zoneInfo) },
                                React.createElement("span", { className: "hide" }, "\uC0AD\uC81C")))),
                    React.createElement("ul", null,
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uD68C\uC0AC \uBA85"),
                            React.createElement("p", { className: "txt" }, companyInfo.companyName)),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uC0AC\uC5C5\uC7A5 \uBA85"),
                            React.createElement("p", { className: "txt" }, zoneInfo.zoneName)),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uC0AC\uC5C5\uC7A5 \uC8FC\uC18C"),
                            React.createElement("p", { className: "txt" }, zoneInfo.address)),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uBA54\uBAA8"),
                            React.createElement("p", { className: "txt h66" }, zoneInfo.memo))),
                    React.createElement("ul", { className: "brd-top-1 mt-26 pt-32" },
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uC0C1\uC138\uC0AC\uC5C5\uC7A5"),
                            React.createElement("p", { className: "txt" },
                                React.createElement("span", { className: "fontMedium mr-4" }, zoneInfo.subZoneCount),
                                "\uAC1C")),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uB4F1\uB85D \uAE30\uAE30"),
                            React.createElement("p", { className: "txt" },
                                React.createElement("span", { className: "fontMedium mr-4" }, zoneInfo.itemCount),
                                "\uAC1C")),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "User"),
                            React.createElement("p", { className: "txt" },
                                React.createElement("span", { className: "fontMedium mr-4" }, zoneInfo.userCount),
                                "\uBA85")),
                        React.createElement("li", { className: "mt-30" },
                            React.createElement("p", { className: "tit" }, "\uC9C4\uB2E8 \uC810\uC218 \uAE30\uC900"),
                            React.createElement("div", { className: "txt column" },
                                React.createElement("div", { className: "result__score" },
                                    React.createElement("p", { className: "tit caution" }, "Warning"),
                                    React.createElement("p", { className: "score" }, zoneInfo.assessmentScore)),
                                React.createElement("p", { className: "score__info" },
                                    "\uC810\uC218\uAE30\uC900\uC744 \uCDA9\uC871\uD558\uC9C0 \uC54A\uC73C\uBA74, \uD574\uB2F9 \uBA54\uC138\uC9C0\uAC00 \uCD9C\uB825\uB429\uB2C8\uB2E4.",
                                    React.createElement("br", null),
                                    '"' + zoneInfo.alarmMessage + '"'))))))),
        React.createElement("div", { className: "popup__footer" },
            React.createElement("button", { type: "button", 
                /*   className="btn-close" */
                onClick: (e) => onClickClose(e) },
                React.createElement("span", null, "\uD655\uC778")))));
}
function ZoneUpdatePopup(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    //화면 이동
    const navigate = useNavigate();
    //첨부 이미지 처리 ref
    const fileRef = useRef();
    //props func
    const selTree = props.selTree;
    const setParentSelTree = props.setSelTree;
    const workMode = props.workMode;
    const setParentWorkMode = props.setWorkMode;
    const setParentPopWin = props.setPopWin;
    const companyInfo = props.companyInfo;
    const updateCount = props.updateCount;
    const setParentUpdateCount = props.setUpdateCount;
    //
    const [zoneInfo, setZoneInfo] = useState(null);
    useEffect(() => {
        setZoneInfo(props.zoneInfo);
        setCropedImage(null);
    }, [props.zoneInfo, updateCount]);
    //const zoneInfo = props.zoneInfo;
    //const setZoneInfo = props.setZoneInfo;
    /*
      const { data: retData, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/product/company/zone/admindetail?zoneId=${props.zoneInfo.zoneId}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token, // url 직접 접근시 로그인 정보 사라짐..
        //watch: props.zoneInfo.zoneId+workMode
        watch: props.zoneInfo
      });
    
      useEffect(() => {
        setRecoilIsLoadingBox(true);
        const ERR_URL = HTTPUTIL.resultCheck(isLoading, retData);
        if (ERR_URL.length > 0) navigate(ERR_URL);
    
        if (retData) {
          //clog("IN ZONE UPDATE POPUP : RES : " + JSON.stringify(retData));
          if (retData.codeNum == CONST.API_200) {
            setZoneInfo(retData.body);
          }
        }
        setRecoilIsLoadingBox(false);
      }, [retData])
    */
    function callbackSetZoneInfoMemo(val) {
        setZoneInfo(Object.assign(Object.assign({}, zoneInfo), { memo: val }));
    }
    function callbackSetZoneInfoAddress(val) {
        setZoneInfo(Object.assign(Object.assign({}, zoneInfo), { address: val }));
    }
    const [errorList, setErrorList] = useState([]);
    const [isPopupPostCode, setIsPopupPostCode] = useState(false);
    useEffect(() => {
        setParentPopWin("pop-postcode", React.createElement(EhpPostCode, { isPopup: isPopupPostCode, setIsPopup: setIsPopupPostCode, setAddress: callbackSetZoneInfoAddress }));
    });
    function onClickPostCode(e) {
        setIsPopupPostCode(true);
        CUTIL.jsopen_Popup(e);
    }
    function saveAttachFiles(zoneId, fileFormData) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "POST",
                "appPath": `/api/v2/product/company/zone/images?zoneId=${zoneId}`,
                appQuery: fileFormData,
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    clog("IN ZONE CREATE : saveFiles : " + JSON.stringify(data));
                }
                else { // api if
                    // need error handle
                }
            }
            //return data;
        });
    }
    function onClickDoUpdateZone(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            setRecoilIsLoadingBox(true);
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "PUT",
                "appPath": `/api/v2/product/company/zone/${zoneInfo.zoneId}`,
                appQuery: {
                    "zoneName": zoneInfo.zoneName,
                    "address": zoneInfo.address,
                    "memo": zoneInfo.memo,
                    "assessmentScore": zoneInfo.assessmentScore
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                const ERR_URL = HTTPUTIL.resultCheck(false, data);
                if (ERR_URL.length > 0) {
                    setRecoilIsLoadingBox(false);
                    CUTIL.sleep(500);
                    navigate(ERR_URL);
                }
                if (data.codeNum == CONST.API_200) {
                    clog("IN ZONE UPDATE : onClickDoUpdateZone : " + JSON.stringify(data.body));
                    if (cropedImage) {
                        saveAttachFiles(data.body.zoneId, cropedImage.fileForm);
                    }
                    setParentPopWin("pop-listbox-detail", React.createElement(ZoneViewPopup, { htmlHeader: React.createElement("h1", null, "\uC0AC\uC5C5\uC7A5 \uC0C1\uC138 \uC815\uBCF4"), zoneInfo: data.body, companyInfo: companyInfo, setSelTree: props.setSelTree, setWorkMode: props.setWorkMode, setPopWin: props.setPopWin }));
                    CUTIL.jsclose_Popup("pop-listbox-detail-edit");
                    CUTIL.sleep(500);
                    setParentSelTree("COMPANY", Object.assign(Object.assign({}, selTree), { company: { "companyId": companyInfo.companyId, "companyName": companyInfo.companyName }, reload: true }));
                    setParentWorkMode("READ");
                    setParentUpdateCount(0);
                }
                else { // api if
                    // need error handle
                    setErrorList(data.body.errorList);
                }
            }
            setRecoilIsLoadingBox(false);
        });
    }
    // option 선택 시  값 변경 액션
    function selectOptionScore(optionElement) {
        const selectBox = optionElement.closest(".select");
        const selectedElement = selectBox.querySelector(".selected-value ");
        selectedElement.textContent = optionElement.textContent;
        var optionData = optionElement.getAttribute("data-value");
        selectedElement.setAttribute("data-value", optionData);
        //
        setZoneInfo(Object.assign(Object.assign({}, zoneInfo), { assessmentScore: optionData }));
    }
    //clog("IN ZONEUPDATE POPUP : INIT : " + JSON.stringify(zoneInfo));
    const [selectedFiles, setSelectedFiles] = useState(null);
    const [cropedImage, setCropedImage] = useState(null);
    useEffect(() => {
        setParentPopWin("pop-imgcrop", React.createElement(EhpImageCrop, { cropImage: selectedFiles, setCropedImage: handleSetCropedImage }));
    }, [selectedFiles]); // selected files이 변경될때마다...이미지 반영을 위해
    // 로컬 파일 URL을 통해 파일 객체 데이터 화
    function handleSetCropedImage(cropVal) {
        //clog("save croped file : " + JSON.stringify(cropVal));
        //var imgDataUrl = sigCanvas.toDataURL('image/png');
        var binaryData = atob(cropVal.url.split(',')[1]);
        var array = [];
        for (var i = 0; i < binaryData.length; i++) {
            array.push(binaryData.charCodeAt(i));
        }
        var file = new File([new Uint8Array(array)], cropVal.name, { type: 'image/png' });
        const formData = new FormData();
        formData.append("files", file);
        var fileVal = {
            fileId: "INS_0",
            name: file.name,
            url: URL.createObjectURL(file),
            type: "INS",
            fileForm: formData,
        };
        setCropedImage(fileVal);
    }
    ;
    // 파일 선택창 업로드
    function onClickFileAdd(e) {
        clog("onClickFileAdd : " + "");
        fileRef.current.value = "";
        fileRef.current.setAttribute("data-pop", "pop-imgcrop"); // data-pop 사라지는 듯....
        fileRef.current.click();
    }
    // 파일 선택창에서 파일 선택시, 처리 기능
    function onChangeFileSelected(e) {
        clog("save attach file : " + JSON.stringify(e.target.files[0]));
        const files = e.target.files;
        const formData = new FormData();
        formData.append("files", files[0]);
        var fileVal = {
            fileId: "INS_0",
            name: files[0].name,
            url: URL.createObjectURL(files[0]),
            type: "INS",
            fileForm: formData,
        };
        setSelectedFiles(fileVal);
        // pop-up 오픈
        CUTIL.jsopen_Popup(e);
    }
    ;
    function onClickClose(e) {
        var popupVal = e.target.getAttribute("data-pop");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-pop", "pop-listbox-detail");
        CUTIL.jsclose_Popup("pop-listbox-detail-edit");
        CUTIL.jsopen_Popup(e);
        setErrorList([]);
        setParentUpdateCount(updateCount + 1);
    }
    return (React.createElement(React.Fragment, null,
        (zoneInfo) && React.createElement("div", { className: "popup__body" },
            React.createElement("div", { className: "workplace__info mt-16" },
                React.createElement("div", { className: "img_workplace" },
                    React.createElement("div", { className: "btn-imgadd" },
                        React.createElement("label", { onClick: (e) => onClickFileAdd(e) },
                            React.createElement("span", { className: "hide" }, "\uC0AC\uC9C4\uCCA8\uBD80")),
                        React.createElement("input", { type: "file", id: "img", ref: fileRef, accept: "image/jpg, image/jpeg, image/png", multiple: true, style: { display: "none" }, onChange: (e) => onChangeFileSelected(e) })),
                    React.createElement("div", { id: "image_preview" }, (cropedImage)
                        ? React.createElement("img", { src: cropedImage.url, alt: cropedImage.name })
                        : (zoneInfo.image !== null)
                            ? React.createElement("img", { src: zoneInfo.image.url, alt: zoneInfo.image.name })
                            : React.createElement("img", { src: require("/static/img/img_workplace/bg_add.jpg"), alt: "\uC0AC\uC9C4\uC601\uC5ED" }))),
                React.createElement("div", { className: "txt_workplace" },
                    React.createElement("div", { className: "page-top" },
                        React.createElement("h2", null,
                            companyInfo.companyName,
                            " ",
                            zoneInfo.zoneName)),
                    React.createElement("ul", { className: "form__input" },
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uD68C\uC0AC \uBA85"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("input", { type: "text", id: "inp1", placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694", disabled: true, value: companyInfo.companyName }))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uC0AC\uC5C5\uC7A5 \uBA85"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("input", { type: "text", id: "inp2", placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694", value: zoneInfo.zoneName, className: (errorList.filter(err => (err.field === "zoneName")).length > 0) ? "input-error" : "", onChange: (e) => setZoneInfo(Object.assign(Object.assign({}, zoneInfo), { zoneName: e.target.value })) }),
                                React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "zoneName")).map((err) => err.msg)))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uC0AC\uC5C5\uC7A5 \uC8FC\uC18C"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("div", { className: "box__search" },
                                    React.createElement("input", { type: "text", placeholder: "\uC9C1\uC811\uC785\uB825", className: (errorList.filter(err => (err.field === "address")).length > 0) ? "input-error" : "", value: zoneInfo.address, disabled: true }),
                                    React.createElement("button", { type: "button", className: "btn btn-search", "data-pop": "pop-postcode", onClick: (e) => onClickPostCode(e) },
                                        React.createElement("span", { className: "hide" }, "\uC870\uD68C"))),
                                React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "address")).map((err) => err.msg)))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uBA54\uBAA8"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("textarea", { placeholder: "\uBA54\uBAA8\uB97C \uC785\uB825\uD558\uC138\uC694.", className: (errorList.filter(err => (err.field === "memo")).length > 0) ? "input-error" : "", value: zoneInfo.memo, onKeyPress: (e) => CUTIL.beforeHandleComment(e, 120), onKeyUp: (e) => CUTIL.afterHandleComment(e, 120, callbackSetZoneInfoMemo), onChange: (e) => setZoneInfo(Object.assign(Object.assign({}, zoneInfo), { memo: e.target.value })) }),
                                React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "memo")).map((err) => err.msg))))),
                    React.createElement("ul", { className: "brd-top-1 mt-26 pt-32" },
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uC0C1\uC138\uC0AC\uC5C5\uC7A5"),
                            React.createElement("p", { className: "txt" },
                                React.createElement("span", { className: "fontMedium mr-4" }, zoneInfo.subZoneCount),
                                "\uAC1C")),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uB4F1\uB85D \uAE30\uAE30"),
                            React.createElement("p", { className: "txt" },
                                React.createElement("span", { className: "fontMedium mr-4" }, zoneInfo.itemCount),
                                "\uAC1C")),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "User"),
                            React.createElement("p", { className: "txt" },
                                React.createElement("span", { className: "fontMedium mr-4" }, zoneInfo.userCount),
                                "\uBA85")),
                        React.createElement("li", { className: "mt-30" },
                            React.createElement("p", { className: "tit mt-8" }, "\uC9C4\uB2E8 \uC810\uC218 \uAE30\uC900"),
                            React.createElement("div", { className: "txt column" },
                                React.createElement("div", { className: "result__score" },
                                    React.createElement("p", { className: "tit caution" }, "Warning"),
                                    React.createElement("div", { className: "score" },
                                        React.createElement("div", { className: "select w64", onClick: (e) => CUTIL.onClickSelect(e, selectOptionScore) },
                                            React.createElement("div", { className: "selected" },
                                                React.createElement("div", { className: "selected-value" }, zoneInfo.assessmentScore),
                                                React.createElement("div", { className: "arrow" })),
                                            React.createElement("ul", null,
                                                React.createElement("li", { className: `option ${(zoneInfo.assessmentScore === 70) ? "on" : ""}`, "data-value": "50" }, "50"),
                                                React.createElement("li", { className: `option ${(zoneInfo.assessmentScore === 70) ? "on" : ""}`, "data-value": "55" }, "55"),
                                                React.createElement("li", { className: `option ${(zoneInfo.assessmentScore === 70) ? "on" : ""}`, "data-value": "60" }, "60"),
                                                React.createElement("li", { className: `option ${(zoneInfo.assessmentScore === 70) ? "on" : ""}`, "data-value": "65" }, "65"),
                                                React.createElement("li", { className: `option ${(zoneInfo.assessmentScore === 70) ? "on" : ""}`, "data-value": "70" }, "70"),
                                                React.createElement("li", { className: `option ${(zoneInfo.assessmentScore === 75) ? "on" : ""}`, "data-value": "75" }, "75"),
                                                React.createElement("li", { className: `option ${(zoneInfo.assessmentScore === 80) ? "on" : ""}`, "data-value": "80" }, "80"),
                                                React.createElement("li", { className: `option ${(zoneInfo.assessmentScore === 85) ? "on" : ""}`, "data-value": "85" }, "85"),
                                                React.createElement("li", { className: `option ${(zoneInfo.assessmentScore === 90) ? "on" : ""}`, "data-value": "90" }, "90"))))),
                                React.createElement("p", { className: "score__info" }, zoneInfo.alarmMessage))))))),
        React.createElement("div", { className: "popup__footer" },
            React.createElement("button", { type: "button", className: "bg-gray btn-close", onClick: (e) => onClickClose(e) },
                React.createElement("span", null, "\uCDE8\uC18C")),
            React.createElement("button", { type: "button", className: "btn-blue", onClick: (e) => onClickDoUpdateZone(e) },
                React.createElement("span", null, "\uC800\uC7A5")))));
}
